import React from "react";
import ComingSoonPanel from "../components/ComingSoonPanel";

const SingleProfitPage: React.FC = () => {
    return (
        <ComingSoonPanel
            title="単品利益"
            description="商品単位の売上・原価・広告費・利益を表示する想定です。"
        />
    );
};

export default SingleProfitPage;
